import { required, confirmed, length, email, is, required_if } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

const testEmpty = (value) =>
  (Array.isArray(value) && value.length === 0 ) || !String(value).trim().length;

extend("required", {
  ...required,
  params: ['msg'],
  message: (fieldName, placeholders) => { return  fieldName + ' ' + placeholders.msg;  }
});

extend("email", {
  ...email,
  params: ['msg'],
  message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg; }
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match"
});

extend("length", {
  ...length,
  message: "This field must have 2 options"
});

extend("phone", {
    validate: value => {
        const pattern =
            /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        return pattern.test(value);
    },
    params: ['msg'],
    message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg; }
});

extend("is", {
    ...is,
    params: ['value','msg'],
    message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg; }
});

extend("customIs", {
  validate: (value, { other, msg }) => {
    return value === other;
  },
  params: [
    {
      name: 'other'
    },
    {
      name: 'msg'
    }
  ],
  message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg; }
})

extend("required_if", {
  ...required_if,
  message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg;  }
});

extend("customRequiredIf", {
  validate: (value, { target, values, msg}) => {
    let required;
    if (values && values.length) {
    if (!Array.isArray(values) && typeof values === 'string') {
      values = [values];
    }

    // eslint-disable-next-line
    required = values.some((val) => val == String(target).trim());
    } else {
      required = !testEmpty(target);
    }

    if (!required) {
      return {
        valid: true,
        required
      };
    }

    return {
      valid: !testEmpty(value),
      required
    };
    },
  params: [
    {
      name: 'target',
      isTarget: true
    },
    {
      name: 'values'
    },
    {
      name: 'msg'
    }
  ],
  message: (fieldName, placeholders) => { return fieldName + ' ' + placeholders.msg; },
  computesRequired: true
});

